import React from 'react';
import { roadmapData } from './roadmapData';
import './Roadmap.css'; // We'll create this for styling

const RoadmapItem = ({ item, isFirst, isLast }) => {
  return (
    <div className="roadmap-item-container">
      <div className="roadmap-item-timeline">
        <div className="roadmap-item-dot"></div>
        {!isLast && <div className="roadmap-item-line"></div>}
      </div>
      <div className="roadmap-item-content">
        <h3>{item.quarter} - {item.title}</h3>
        <p>{item.description}</p>
        <ul>
          {item.keyPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
        <span className={`roadmap-item-status ${item.status.toLowerCase()}`}>{item.status}</span>
      </div>
    </div>
  );
};

const Roadmap = ({ title }) => {
  const quarters = ['Q1 2025', 'Q2 2025', 'Q3 2025', 'Q4 2025'];
  const itemsByQuarter = quarters.map(quarter => ({
    quarter,
    items: roadmapData.filter(item => item.quarter === quarter)
  }));

  return (
    <div className="roadmap-container">
      <h2 style={{ textAlign: 'center', color: '#4a148c', paddingTop: '20px', marginBottom: '30px', fontFamily: 'Arial, sans-serif' }}>
        {title || "Artemis Project: 12-Month Roadmap"}
      </h2>
      <div className="roadmap-timeline-view">
        {itemsByQuarter.map(({ quarter, items }, quarterIndex) => (
          <div key={quarter} className="roadmap-quarter-column">
            <h4>{quarter}</h4>
            <div className="roadmap-quarter-items">
              {items.map((item, itemIndex) => (
                <RoadmapItem 
                  key={item.id} 
                  item={item} 
                  isFirst={itemIndex === 0 && quarterIndex === 0}
                  isLast={itemIndex === items.length -1 && quarterIndex === itemsByQuarter.length -1 && items.length > 0 } // Only truly last if it's the last item of the last quarter
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Roadmap; 